<template>
<svg viewBox="-46.545 -46.545 1117.091 1117.091" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-qdrant`]" width="1em" height="1em" v-bind="$attrs"><path d="M953.995636 257.363117l0.053195-0.033247-219.428571-126.67013L515.244883 3.98961l-219.428571 126.67013L76.454234 257.32987l0.013298 0.026598V764.01039l219.368728 126.670129 219.428571 126.67678v0.013298l140.367792-80.989091 0.00665-0.006649-0.00665-0.006649V764.01039l-140.367792 81.062233-144.822857-83.588987-144.756364-83.582337V343.512104l144.756364-83.582338 144.822857-83.582337 144.756364 83.582337 144.822857 83.582338v673.845195l-0.013299-0.00665 0.026598 0.046546 149.211428-86.11574V257.369766l-0.073143-0.006649zM374.897039 429.700987V591.725714l140.367792 81.055585L655.625974 591.725714V429.687688l-0.019948 0.013299-0.066494-0.066493L515.271481 348.625455 374.916987 429.66774l-0.013299 0.033247h-0.006649z" :fill="useCurrentColor ? 'currentColor' : '#DC244C'"/></svg>
</template>
<script>

export default {
  name: 'IconColorQdrant',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
